import * as React from 'react';
import { Fragment } from 'react';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';

const CommentaryContent = styled<any, any>('div')`
    ${propStyles};
`;

CommentaryContent.defaultProps = {
    fontSize: "sm",
    fontFamily: "body",
    fontWeight: "normal",
    lineHeight: "1.4",
    color: "body",
    listStyle: "none",
    marginY: "md"
};

interface CommentariesProps {
    theme?: { [property: string]: string | number };
    commentaries: Array<string>;
}

export const Commentaries: React.SFC<CommentariesProps> = ({ theme, commentaries = [], ...props }) => (
    commentaries.length > 0 ? (
        <Fragment>
            {
                commentaries.map((commentary, index) =>
                    <CommentaryContent
                        key={index}
                        dangerouslySetInnerHTML={{ __html: commentary }}
                        {...theme.CommentaryContent}
                        {...props}
                    />
                )
            }
        </Fragment>
    ) : null
);

export default observer(withTheme(Commentaries));


// WEBPACK FOOTER //
// ./src/Components/Commentaries.tsx